import axios from 'axios';
import thaiFormat from '../lib/thaiFormat'

function delimeter(data) {
    let y = parseFloat(data).toFixed(2)
    let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return x

}
Array.prototype.insert = function (index, item) {
    this.splice(index, 0, item);
};
const invoice_pdf = async function (data, list, isReciept) {
    let product = list
    let sum = product.reduce((a, b) => a + parseFloat(b['PRICE'] * b['AMOUT']), 0)
    let is_split = []
    // console.log(data)
    let vat_value = parseFloat(data.TVAT_VALUE) //(sum * parseInt(data.VAT_VALUE)) / 100
    let total = sum + vat_value

    if (data.SPLIT_PAY == 1) {
        is_split = [{
                columns: [

                    {
                        text: '',
                        bold: true
                    },
                    {
                        columns: [{
                                text: 'รวมเป็นเงิน',
                                bold: true,
                                alignment: 'right'
                            },
                            {
                                text: `${delimeter(sum)} บาท`,
                                bold: true,
                                alignment: 'right'
                            }
                        ],

                    },

                ],
            },
            {
                columns: [

                    {
                        text: '',
                        bold: true
                    },
                    {
                        columns: [{
                                text: `แบ่งชำระ ${data.SPLIT_OPTION == 'เปอร์เซ็นต์' ? data.SPLIT_VALUE + ' %' : data.SPLIT_VALUE + ' บาท'}`,
                                bold: true,
                                alignment: 'right'
                            },
                            {
                                text: `${delimeter(parseFloat(data.PAID_NO_VAT))} บาท`,
                                bold: true,
                                alignment: 'right'
                            }
                        ],

                    },

                ],
            },
            {
                columns: [

                    {
                        text: '',
                        bold: true
                    },
                    {
                        columns: [{
                                text: 'ภาษีมูลค่าเพิ่ม 7%',
                                bold: true,
                                alignment: 'right'
                            },
                            {
                                text: `${delimeter(vat_value)} บาท`,
                                bold: true,
                                alignment: 'right'
                            }
                        ],

                    },

                ],
            },
            {
                columns: [

                    {
                        text: `(${thaiFormat(parseFloat(data.PAID_VAT))})`,
                        bold: true
                    },
                    {
                        columns: [{
                                text: 'จำนวนรวมทั้งสิ้น',
                                bold: true,
                                alignment: 'right'
                            },
                            {
                                text: `${delimeter(parseFloat(data.PAID_VAT))} บาท`,
                                bold: true,
                                alignment: 'right'
                            }
                        ],

                    },

                ],
            }
        ]
    } else {
        is_split = [{
                columns: [

                    {
                        text: '',
                        bold: true
                    },
                    {
                        columns: [{
                                text: 'รวมเป็นเงิน',
                                bold: true,
                                alignment: 'right'
                            },
                            {
                                text: `${delimeter(sum)} บาท`,
                                bold: true,
                                alignment: 'right'
                            }
                        ],

                    },

                ],
            },
            {
                columns: [

                    {
                        text: '',
                        bold: true
                    },
                    {
                        columns: [{
                                text: 'ภาษีมูลค่าเพิ่ม 7%',
                                bold: true,
                                alignment: 'right'
                            },
                            {
                                text: `${delimeter(vat_value)} บาท`,
                                bold: true,
                                alignment: 'right'
                            }
                        ],

                    },

                ],
            },
            {
                columns: [

                    {
                        text: `(${thaiFormat(total)})`,
                        bold: true
                    },
                    {
                        columns: [{
                                text: 'จำนวนรวมทั้งสิ้น',
                                bold: true,
                                alignment: 'right'
                            },
                            {
                                text: `${delimeter(total)} บาท`,
                                bold: true,
                                alignment: 'right'
                            }
                        ],

                    },

                ],
            }
        ]
    }
    is_split.push({
        columns: data.IS_DISCOUNT ? [{
                text: ``,
                bold: true,
                margin: [0, 10, 0, 0]
            },
            {
                columns: [{
                        text: '',
                        bold: true,
                        alignment: 'right',
                        margin: [0, 10, 0, 0]
                    },
                    {
                        text: ``,
                        bold: true,
                        alignment: 'right',
                        margin: [0, 10, 0, 0]
                    }
                ],

            },

        ] : [],
    }, {
        columns: data.IS_DISCOUNT ? [

            {
                text: ``,
                bold: true
            },
            {
                columns: [{
                        text: `${data.DISCOUNT_TYPE}`,
                        bold: true,
                        alignment: 'right'
                    },
                    {
                        text: `${delimeter(data.DISCOUNT_VALUE)} บาท`,
                        bold: true,
                        alignment: 'right'
                    }
                ],

            },

        ] : [],
    }, {
        columns: data.ISVAT2 ? [

            {
                text: ``,
                bold: true
            },
            {
                columns: [{
                        text: `หัก ณ ที่จ่าย ${data.VAT_VALUE2}`,
                        bold: true,
                        alignment: 'right'
                    },
                    {
                        text: `${delimeter(sum * (parseInt(data.VAT_VALUE2) / 100))} บาท`,
                        bold: true,
                        alignment: 'right'
                    }
                ],

            },

        ] : [],
    }, {
        columns: data.IS_DISCOUNT || data.ISVAT2 ? [

            {
                text: ``,
                bold: true
            },
            {
                columns: [{
                        text: 'ยอดชำระ',
                        bold: true,
                        alignment: 'right'
                    },
                    {
                        text: `${delimeter(data.ACTUAL_PAY)} บาท`,
                        bold: true,
                        alignment: 'right'
                    }
                ],

            },

        ] : [],
    })
    let product_list = [
        [{
            text: 'ลำดับ',
            style: 'tableHeader'
        }, {
            text: 'รายละเอียด',
            style: 'tableHeader'
        }, {
            text: 'จำนวน',
            style: 'tableHeader'
        }, {
            text: 'ราคาต่อหน่วย',
            style: 'tableHeader'
        }, {
            text: 'มูลค่า',
            style: 'tableHeader'
        }],
        [{
                colSpan: 5,
                type: 'none',
                ul: is_split

            },
            '',
            '',
            '',
            ''
        ]
    ]

    for (let i = product.length - 1; i >= 0; i--) {
        product[i].UNIT = product[i].UNIT != null ? product[i].UNIT : "\xa0\xa0"
        product_list.insert(1, [{
            text: i + 1,
            alignment: "center",
            bold: true
        }, {
            text: product[i].NAME + '\n' + product[i].DETAIL,
            alignment: "left",
            bold: true
        }, {
            text: product[i].AMOUT + ' ' + product[i].UNIT,
            alignment: "center",
            bold: true
        }, {
            text: delimeter(product[i].PRICE),
            alignment: "right",
            bold: true
        }, {
            text: delimeter(parseInt(product[i].PRICE * product[i].AMOUT)),
            alignment: "right",
            bold: true
        }]);

    }

    const pdf = {
        pageSize: 'A4',
        // pageMargins: [ 30, 0, 30, 0 ],
        footer(currentPage, pageCount) {
            return {
                columns: [
                    // { text: "ท้ายกระดาษ", fontSize: 15, alignment: "center" },
                    {
                        // text:
                        //     "หน้าที่ " +
                        //     currentPage.toString() +
                        //     " จาก " +
                        //     pageCount +
                        //     " หน้า",
                        // margin: [5, 5, 15, 5],
                        // alignment: "right"
                    }
                ]
            };
        },
        footer: {

        },
        content: [

            {
                alignment: 'justify',
                columns: [
                    [{

                            image: await getBase64ImageFromURL(
                                "https://res.cloudinary.com/dfgnhewbg/image/upload/v1595224134/newchok-icon_tuzsem.png"
                            ),
                            alignment: "left",
                            width: 65,
                        },
                        {
                            columns: [{

                                    text: ''+this.$AppName.limited_company+' (สำนักงานใหญ่) \n 389/40 ตำบล สันผีเสื้อ อำเภอเมืองเชียงใหม่ เชียงใหม่  50300 \n เลขประจำตัวผู้เสียภาษี 0505563001372 \n โทร. 053-106163 \n เบอร์มือถือ 081-5959004    0816949845 \n www.chokumnuai.com',
                                    bold: true
                                }

                            ]
                        }
                    ],
                    [{
                            text: `ใบกำกับภาษี / ใบเสร็จรับเงิน`,
                            style: 'header',
                            alignment: "right",
                            margin: [0, 0, 0, 10]
                        }, //left top right bottom
                        {
                            columns: [{
                                    text: 'เลขที่',
                                    alignment: 'right',
                                    bold: true
                                },
                                {
                                    text: `${data.INVOICE_ID}`,
                                    alignment: 'right',
                                    bold: true
                                },

                                // {
                                //     text: 'เลขที่    QT2020090029\nวันที่     28/09/2020\nผู้ขาย    newchok.2019@gmail.com\nผูติดต่อ   กมลทิพย์ สุจริตวณิช\nเบอร์โทร 0858145158\nอีเมล    maxgamix@hotmail.com',
                                //     alignment: 'right'
                                // }
                            ],

                        },
                        {
                            columns: [{
                                    text: 'วันที่',
                                    alignment: 'right',
                                    bold: true
                                },
                                {
                                    text: `${data.DOC_DATE}`,
                                    alignment: 'right',
                                    bold: true
                                }

                            ]
                        },
                        {
                            columns: [{
                                    text: 'อ้างอิง',
                                    alignment: 'right',
                                    bold: true
                                },
                                {
                                    text: `${data.BILL_ID}`,
                                    alignment: 'right',
                                    bold: true
                                }

                            ]
                        },
                        // {
                        //     columns: [
                        //         {
                        //             text: 'ผู้ติดต่อ',
                        //             alignment: 'right',
                        //             bold: true
                        //         },
                        //         {
                        //             text: '',
                        //             alignment: 'right',
                        //             bold: true
                        //         }


                        //     ],

                        // },
                        // {
                        //     columns: [
                        //         {
                        //             text: 'เบอร์โทร',
                        //             alignment: 'right',
                        //             bold: true
                        //         },
                        //         {
                        //             text: '',
                        //             alignment: 'right',
                        //             bold: true
                        //         }

                        //     ]
                        // },
                        // {
                        //     columns: [
                        //         {
                        //             text: 'อีเมล',
                        //             alignment: 'right',
                        //             bold: true
                        //         },
                        //         {
                        //             text: '',
                        //             alignment: 'right',
                        //             bold: true
                        //         }

                        //     ]
                        // },
                    ]

                ],
                margin: [0, 0, 0, 10],
            },
            {
                alignment: 'justify',
                columns: [

                    {
                        text: `ลูกค้า \n ${data.CUSTOMER_NAME} (${data.CUSTOMER_BRANCH}) \n ตำบล${data.CUSTOMER_SUBDISTRICT} อำเภอ${data.CUSTOMER_DISTRICT}  จังหวัด${data.CUSTOMER_PROVINCE} ${data.CUSTOMER_ZIPCODE} `,
                        width: 230,
                        bold: true
                    }
                ],
                margin: [0, 0, 0, 5],
            },
            {
                table: {
                    widths: [40, 240, 60, 60, 80],
                    body: product_list
                },
                layout: {
                    hLineColor: function (i, node) {
                        // if (i === 0 || i === node.table.widths.length) {
                        //     return null;
                        // }
                        let max_node = node.table.body.length
                        if (i >= 0 && i <= 1) {
                            return '#000';
                        } else if (i === max_node) {
                            return '#000';
                        } else if (i === max_node - 1) {
                            return '#000';
                        } else {
                            return '#fff';
                        }

                    },

                },
                margin: [0, 0, 0, 10]
            },

            {
                alignment: 'left',
                columns: [

                    {
                        text: `หมายเหตุ \n${data.REMARK}`,
                        width: 150,
                        bold: true
                    }
                ],

            },
            {
                alignment: 'justify',
                columns: [

                    {
                        text: `ในนาม ${data.CUSTOMER_NAME}`,
                        bold: true,
                        alignment: 'left',
                        absolutePosition: {
                            x: 40,
                            y: 700
                        }
                    },
                    {
                        image: await getBase64ImageFromURL(
                            "https://res.cloudinary.com/dfgnhewbg/image/upload/v1595224134/newchok-icon_tuzsem.png"
                        ),
                        fit: [100, 100],
                        absolutePosition: {
                            x: 20,
                            y: 700
                        },
                        alignment: 'center'
                    },
                    {
                        text: 'ในนาม '+this.$AppName.limited_company+'',
                        bold: true,
                        absolutePosition: {
                            x: 220,
                            y: 700
                        },
                        alignment: 'right'
                    }
                ],
                margin: [0, 0, 0, 0]
            },
            {
                alignment: 'center',
                columns: [{
                        text: '_____________________\n ผู้สั่งซื้อสินค้า',
                        absolutePosition: {
                            x: -400,
                            y: 770
                        },
                        // alignment: 'center',
                        margin: [0, 0, 5, 0]
                    },
                    {
                        text: '_____________________\n วันที่',
                        absolutePosition: {
                            x: -200,
                            y: 770
                        },
                        alignment: 'center',
                        margin: [5, 0, 5, 0]
                    },
                    {
                        text: '',
                        margin: [15, 0, 15, 0]
                    },
                    {
                        text: '_____________________\n ผู้อนุมัติ',
                        absolutePosition: {
                            x: 260,
                            y: 770
                        },
                        alignment: 'center',
                        margin: [5, 0, 5, 0]
                    },
                    {
                        text: '_____________________\n วันที่',
                        absolutePosition: {
                            x: 460,
                            y: 770
                        },
                        alignment: 'center',
                        margin: [5, 0, 0, 0]
                    },
                ],
            }




        ],
        defaultStyle: {
            font: "THSarabunNew"
        },
        styles: {
            tableHeader: {
                bold: true,
                alignment: 'center'
            },
            tableContent: {
                fontSize: 16,
            },
            header: {
                fontSize: 24,
                alignment: "center",
                bold: true
            },
            header1: {
                fontSize: 16,
                alignment: "center",
                bold: true
            },
            header2: {
                fontSize: 16,
                alignment: "center",
                bold: true
            },
            tableExample: {
                alignment: "center",
                margin: [0, 5, 0, 15]
            },

            content: {
                fontSize: 16,
                alignment: "left",
                margin: [0, 10, 0, 0]
            },
            content_1: {
                bold: true,
                fontSize: 14,
                color: 'black',
                alignment: "left",
                margin: [0, 10, 0, 0]
            },
            content_2: {
                fontSize: 14,
                alignment: "left",
                margin: [0, 10, 0, 0]
            },
            content_3: {
                fontSize: 14,
                alignment: "right",
                margin: [0, 10, 0, 0]
            },
            content_8: {
                fontSize: 14,
                alignment: "left",
                margin: [20, 10, 0, 0]
            },
            signature: {
                fontSize: 14,
                alignment: "center",
                margin: [0, 30, 0, 0]
            }
        }
    };
    return pdf
}

function getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");


            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

export default invoice_pdf